module.exports = require("./es-GT.d.ts");